import { Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { KontoverbindungModel } from '../../shared/model/kontoverbindung.model';

import {
  DefaultService as KontoverbindungenService,
  NeueKontoverbindungPersoenlichDto,
} from '@kontoverbindungen-api';
import { SuxExceptionBase, SuxExceptionService } from '@suva-ch/suvauxlib/modules/exception';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SuxUserService } from '@suva-ch/suvauxlib/modules/auth';
import { ValidationResult } from '../iban-bic/validation-result';

@Component({
  selector: 'kvb-kontoverbindung-edit',
  templateUrl: './kontoverbindung-edit.component.html',
  styleUrl: './kontoverbindung-edit.component.scss',
})
export class KontoverbindungEditComponent extends SuxExceptionBase implements OnInit {
  @Input() kontoverbindung: KontoverbindungModel;
  @Output() kontoverbindungSaved = new EventEmitter<void>();

  private readonly destroyRef = inject(DestroyRef);
  private initialIban: string;

  isSaveButtonDisabled = true;

  constructor(
    private kontoverbindungenService: KontoverbindungenService,
    private suxExceptionService: SuxExceptionService,
    private suxUserService: SuxUserService
  ) {
    super();
  }

  ngOnInit(): void {
    if (!this.kontoverbindung) {
      this.kontoverbindung = {
        iban: '',
        bic: '',
        bank: '',
        zahlungsverbindungId: '',
        inhaber: '',
      };
      this.suxUserService
        .getUser()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: user => (this.kontoverbindung.inhaber = `${user.given_name} ${user.family_name}`),
          error: () => this.addException(this.suxExceptionService.createException()),
        });
    }
    this.initialIban = this.kontoverbindung?.iban;
  }

  saveKontoverbindung() {
    if (this.initialIban === this.getUnformattedIban()) {
      this.kontoverbindungSaved.emit();
    }

    const newKontoverbindung: NeueKontoverbindungPersoenlichDto = {
      iban: this.getUnformattedIban(),
      bic: this.kontoverbindung.bic,
      zahlungsprofile: this.kontoverbindung.zahlungsprofile,
    };

    this.kontoverbindungenService
      .neuePersoenlichKontoverbindung(newKontoverbindung)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.emitKontoverbindungSavedDelayed(),
        error: () => this.addException(this.suxExceptionService.createException()),
      });
  }

  onIbanValidated($event: ValidationResult) {
    this.kontoverbindung.iban = $event.iban;
    this.kontoverbindung.bic = $event.bic;
    this.isSaveButtonDisabled = !$event.isValid;
  }

  private emitKontoverbindungSavedDelayed() {
    setTimeout(() => this.kontoverbindungSaved.emit(), 1000);
  }

  private getUnformattedIban = () => {
    return this.kontoverbindung?.iban?.replace(/\s/g, '');
  };
}
